<template>
  <SelfserviceShortcut
    :categories="categories"
    :initial-state="initialState"
    :link-component="SelfserviceShortcutLink"
    :pulse-duration="pulseDuration"
    :show-less-label="t('overviewSelfserviceShortcut.showLess')"
    :show-more-label="t('overviewSelfserviceShortcut.showMore')"
    :title="t('overviewSelfserviceShortcut.title')"
    tracking-id="overview-selfservice-shortcut"
  ></SelfserviceShortcut>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import {
  SelfserviceShortcut,
  type SelfserviceShortcutInitialState
} from 'de-zurich-ui-library'
import SelfserviceShortcutLink from '@/components/rahmen/SelfserviceShortcutLink.vue'
import { getOverviewSelfserviceShortcutCategories } from '@/utilsTenant/overviewSelfserviceShortcut'

const props = withDefaults(
  defineProps<{
    initialState: SelfserviceShortcutInitialState
    pulseDuration?: number
    pulseActiveDuration?: number
  }>(),
  {
    pulseDuration: 600,
    pulseActiveDuration: 16000
  }
)

const { t } = useI18n()

const categories = computed(() =>
  getOverviewSelfserviceShortcutCategories((key) => t(key).toString())
)

const initialState = computed(() => props.initialState)
const pulseDuration = computed(() => props.pulseDuration)
</script>
